"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Badge = _interopRequireDefault(require("../badge/Badge"));

var _Typography = _interopRequireDefault(require("../typography/Typography"));

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Tab = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var active = _ref.active,
      tab = _ref.tab,
      tabIndex = _ref.tabIndex,
      hasLabelAndIcon = _ref.hasLabelAndIcon,
      iconPosition = _ref.iconPosition,
      _onClick = _ref.onClick,
      _onMouseEnter = _ref.onMouseEnter,
      _onMouseLeave = _ref.onMouseLeave;
  var colorsTheme = (0, _useTheme["default"])();
  return /*#__PURE__*/_react["default"].createElement(TabContainer, {
    role: "tab",
    type: "button",
    tabIndex: tabIndex,
    disabled: tab.isDisabled,
    "aria-disabled": tab.isDisabled,
    "aria-selected": active,
    hasLabelAndIcon: hasLabelAndIcon,
    iconPosition: iconPosition,
    ref: ref,
    onClick: function onClick() {
      _onClick();
    },
    onMouseEnter: function onMouseEnter() {
      _onMouseEnter();
    },
    onMouseLeave: function onMouseLeave() {
      _onMouseLeave();
    }
  }, /*#__PURE__*/_react["default"].createElement(MainLabelContainer, {
    hasBadge: tab.notificationNumber,
    hasLabelAndIcon: hasLabelAndIcon,
    iconPosition: iconPosition
  }, tab.icon && /*#__PURE__*/_react["default"].createElement(TabIconContainer, {
    hasLabelAndIcon: hasLabelAndIcon,
    iconPosition: iconPosition
  }, typeof tab.icon === "string" ? /*#__PURE__*/_react["default"].createElement(TabIcon, {
    src: tab.icon
  }) : tab.icon), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    color: tab.isDisabled ? colorsTheme.tabs.disabledFontColor : active ? colorsTheme.tabs.selectedFontColor : colorsTheme.tabs.unselectedFontColor,
    fontFamily: colorsTheme.tabs.fontFamily,
    fontSize: colorsTheme.tabs.fontSize,
    fontStyle: tab.isDisabled ? colorsTheme.tabs.disabledFontStyle : colorsTheme.tabs.fontStyle,
    fontWeight: active ? colorsTheme.tabs.pressedFontWeight : colorsTheme.tabs.fontWeight,
    textAlign: "center",
    letterSpacing: "0.025em",
    lineHeight: "1.715em"
  }, tab.label)), tab.notificationNumber && tab.notificationNumber && /*#__PURE__*/_react["default"].createElement(BadgeContainer, {
    hasLabelAndIcon: hasLabelAndIcon,
    iconPosition: iconPosition
  }, /*#__PURE__*/_react["default"].createElement(_Badge["default"], {
    notificationText: tab.notificationNumber > 99 ? "+99" : tab.notificationNumber
  })));
});

var TabContainer = _styledComponents["default"].button(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  text-transform: ", ";\n  overflow: hidden;\n  flex-shrink: 0;\n  border: 0;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  user-select: none;\n  vertical-align: middle;\n  justify-content: center;\n  min-width: 90px;\n  max-width: 360px;\n  padding: ", ";\n  height: ", ";\n  min-height: ", ";\n  background-color: ", ";\n  svg {\n    color: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n\n  &:focus {\n    outline: ", " solid 1px;\n    outline-offset: -1px;\n  }\n\n  &[aria-selected=\"true\"] {\n    background-color: ", ";\n    svg {\n      color: ", ";\n    }\n    opacity: 1;\n  }\n\n  &[aria-disabled=\"true\"] {\n    background-color: ", " !important;\n    cursor: not-allowed !important;\n    pointer-events: all;\n    font-style: ", ";\n    svg {\n      color: ", ";\n    }\n    outline: none !important;\n    > div {\n      opacity: 0.5;\n    }\n  }\n"])), function (props) {
  return props.theme.fontTextTransform;
}, function (props) {
  return (!props.hasLabelAndIcon || props.hasLabelAndIcon && props.iconPosition !== "top") && "12px 16px" || "8px 16px";
}, function (props) {
  return (!props.hasLabelAndIcon || props.hasLabelAndIcon && props.iconPosition !== "top") && "47px" || "71px";
}, function (props) {
  return (!props.hasLabelAndIcon || props.hasLabelAndIcon && props.iconPosition !== "top") && "47px" || "71px";
}, function (props) {
  return props.theme.unselectedBackgroundColor;
}, function (props) {
  return props.theme.unselectedIconColor;
}, function (props) {
  return "".concat(props.theme.hoverBackgroundColor, " !important");
}, function (props) {
  return "".concat(props.theme.pressedBackgroundColor, " !important");
}, function (props) {
  return props.theme.focusOutline;
}, function (props) {
  return props.theme.selectedBackgroundColor;
}, function (props) {
  return props.theme.selectedIconColor;
}, function (props) {
  return props.theme.unselectedBackgroundColor;
}, function (props) {
  return props.theme.disabledFontStyle;
}, function (props) {
  return props.theme.disabledIconColor;
});

var BadgeContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: 12px;\n  height: 100%;\n  display: flex;\n  align-items: ", ";\n"])), function (props) {
  return props.hasLabelAndIcon && props.iconPosition === "top" ? "flex-start" : "center";
});

var MainLabelContainer = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: ", ";\n  align-items: center;\n  margin-left: ", ";\n"])), function (props) {
  return props.hasLabelAndIcon && props.iconPosition === "top" && "column" || "row";
}, function (props) {
  return props.hasBadge ? typeof props.hasBadge === "number" ? "calc(".concat(props.theme.badgeWidthWithNotificationNumber, " + 12px)") : "calc(".concat(props.theme.badgeWidth, " + 12px)") : "unset";
});

var TabIconContainer = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  max-height: 22px;\n  max-width: 22px;\n  margin-bottom: ", ";\n  margin-right: ", ";\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  img,\n  svg {\n    height: 100%;\n    width: 100%;\n  }\n"])), function (props) {
  return props.hasLabelAndIcon && props.iconPosition === "top" && "8px" || "";
}, function (props) {
  return props.hasLabelAndIcon && props.iconPosition === "left" && "12px" || "";
});

var TabIcon = _styledComponents["default"].img(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n"])));

var _default = /*#__PURE__*/_react["default"].memo(Tab);

exports["default"] = _default;